/* eslint-disable no-unused-vars */
import { useState, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { campaignLangs, selectTargettingErrorFlag } from 'store/selectors';
import { useToggleState } from './useToggleState';
import { generalActions } from 'store/actions';
import { sortLanguagesByLanguageName } from 'utils';
import { targetingPlacementsActions } from 'store/actions';
import { Languages } from 'constants/dictionary/languages';

export const useFacade = () => {
  const dispatch = useDispatch();

  const [search, setSearch] = useState('');

  const allLanguages = useMemo(() => {
    const res = Languages.languages.reduce(function (acc, { language_code, language_name }) {
      if (!acc.find((item) => item.language_code === language_code)) {
        acc = [...acc, { language_code, language_name }];
        return acc;
      }
      return acc;
    }, []);
    return sortLanguagesByLanguageName(res);
  }, [Languages]);

  const selectedLangs = useSelector(campaignLangs);
  const errorFlag = useSelector(selectTargettingErrorFlag);
  const { state, isActive, toggle, toggleAllOff, saveBtnFlag } = useToggleState(selectedLangs);

  const handleSearchOnChange = useCallback((e) => {
    setSearch(e.target.value || '');
  }, []);

  const faundedLangs = useMemo(() => {
    if (!search) return allLanguages;
    return allLanguages.filter((lang) =>
      lang.language_name.toLowerCase().includes(search.toLowerCase()),
    );
  }, [search]);

  const handleClearSearchValue = useCallback(() => {
    setSearch('');
  }, []);

  const saveButtonClick = useCallback(() => {
    dispatch(
      generalActions.updateCurrentCampaignObj({
        propField: 'campaignLangs',
        newValue: state.join(','),
      }),
    );
    if (errorFlag.languages) {
      dispatch(
        targetingPlacementsActions.updateErrorField({
          errorField: 'languages',
          newValue: false,
        }),
      );
    }
  }, [state, errorFlag.languages]);

  const sortedLangs = useMemo(() => {
    const checkedLangs = faundedLangs?.filter((lang) => isActive(lang.language_code));
    const unCheckedLangs = faundedLangs?.filter((lang) => !isActive(lang.language_code));
    const sortedLangs = checkedLangs.concat(unCheckedLangs);
    return sortedLangs;
  }, [selectedLangs, faundedLangs]);

  return {
    search,
    handleSearchOnChange,
    handleClearSearchValue,
    sortedLangs,
    isActive,
    toggle,
    state,
    toggleAllOff,
    saveButtonClick,
    saveBtnFlag,
  };
};
